import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sentry-error-test")({
	component: RoutePage,
});

function RoutePage() {
	return (
		<button
			type="button"
			onClick={() => {
				throw new Error("This is your first error!");
			}}
		>
			Break the world
		</button>
	);
}
